
import { downgradeComponent } from '@angular/upgrade/static';
import { ReportSelectComponent } from '@fry-it/risr-features/reports';

(function() {
  'use strict';

  angular.module('component.eventTypes')
    .directive('sqlReportSelect', downgradeComponent({
      component: ReportSelectComponent,
      inputs: ['config'],
      outputs: ['configChange']
    }))
    .component('eventTypeSectionField', {
      templateUrl: 'app/components/event-types/event-type-section-field.html',
      controller: 'EventTypeFieldController',
      controllerAs: 'fieldCtrl',
      bindings: {
        eventTypeId: '<',
        sectionId: '<',
        fieldId: '<'
      }
    });
})();
